module.exports = __webpack_public_path__ + "img/DAVID_CANNON_43-rs.68509f0a.jpg";